module.exports = __webpack_public_path__ + "img/transparent.919c5be1.svg";